import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { LowerCasePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { ImageRatioEnum, SdBannerComponent, SdListComponent } from '@seb/web-design-system/core';

import type { IPaymentMode } from './payment-mode.interface';

@Component({
  selector: 'sd-payment-mode',
  templateUrl: './payment-mode.component.html',
  styleUrls: ['./payment-mode.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdListComponent,
    SdBannerComponent,
    LowerCasePipe,
    TranslateModule
  ]
})
export class SdPaymentModeComponent {
  imageRatio = ImageRatioEnum;

  @HostBinding('class.is-order-payment-mode')
  @Input()
  isOrderPaymentMode = false;

  @Input()
  paymentMode: IPaymentMode;

  @Input()
  titleHidden = true;
}
